import {
  makeAddressArraySync,
  makeAddressSync,
  ProtocolConfig,
} from "@silo/types";
import { satisfies } from "effect/Function";
import { MARKET_ADDRESS } from "../market-address";
import { TOKEN_ADDRESS } from "../token-address";

export const base = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "ETH",
  secondBridgeSymbol: "USDC",
  marketWhitelist: new Set([
    MARKET_ADDRESS.base.cbETH,
    MARKET_ADDRESS.base.ezETH,
    MARKET_ADDRESS.base.AERO,
    MARKET_ADDRESS.base.cbBTC,
  ]),
  pinnedMarkets: [],
  markets: {
    [MARKET_ADDRESS.base.sUSDz]: {
      depositMode: {
        base: "protectedOnly",
      },
      points: {
        base: {
          protected: [
            {
              _tag: "anzen",
              label: "5x Anzen",
            },
          ],
        },
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.wSuperOETHb]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.hyUSD]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.DEGEN]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.tBTC]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.EURC]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.pumpBTC]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.wUSDPlus]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.bsdETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.wstETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.base.weETH]: {
      labelAsDeprecated: true,
    },
  },
  nativeRewards: {
    siloIncentivesControllerAddress: makeAddressSync(
      "0x626e6A8D4EB33D77A8b631ABfE2E98dA69E3100e"
    ),
    tokenAddress: TOKEN_ADDRESS.base.SILO,
    symbol: "SILO",
    decimals: 18,
    historicalShareTokens: {
      [TOKEN_ADDRESS.base.SILO]: makeAddressArraySync([
        //scbETH
        "0x0EAF454178a109aB0FBda04BF4e3d67B56B893Dd",
        //USDC-cbETH
        "0x720b4D1b73152DF126cC26fE1756F277F6b0D0bc",
        //sweth-cbETH
        "0xbC6EDb37A3b55dfCE4c3bfc9c14AC968ffE65cDF",
        //swstETH
        "0x1f97c8Cec41295c95c7612c5Dd0F0c973d187ba2",
        //USDC-wstETH
        "0x583912292928aA54244f2Bb5422DAF268e7be77F",
        //sWETH-wstETH
        "0x7eB30E1734A08a8F7688C4dAA2f85a7E8c7c33c8",
        //sezETH
        "0x65936852e7c657714d5b9AF9f36F4F31ac39a247",
        //wETH-ezETH
        "0xF26513B8f59c4c2dd050C516e1d91Ce09A636518",
        //USDC-ezETH
        "0x7bB1405E0D44a4639D83f7B263194211CD17bfD5",
        //sbsdETH
        "0x4799FCa83383dc544CbfE2E484D3C8EaCaC4B5aA",
        //sETH-bsdETH
        "0x2D644C56B7fcd08dEbBECFe7dfA9ca0131Db98F5",
        //USDC-bsdETH
        "0xc2805e9d6E89FE145DCe5a4Abc014B29C7BDe25B",
        //sweETH
        "0x5eDe368eA75a5337c63E79486D4B39Fc594BAD50",
        //sWETH-weETH
        "0xB2130bF12900fd76FB9Cf85D780CaF7F984D8a9f",
        //USDC-weETH
        "0x9C5cc5A9Ddb9760c0F455cE94cfbe2b89eDD185a",
        // sAERO
        "0xd7643B1257Ea82Ea86433e70DAF064200AB2001f",
        //USDC-AERO
        "0x0cC296F023800D4B2485659c79e17b10C79fF5DB",
        //scbBTC
        "0x6B69a1cDc054C3D873A882eF53bD0612422c365F",
        //sWETH-cbBTC
        "0x045A8e383B64378fAf7Fc73FdeF6049cC0C05c85",
        //USDC-cbBTC
        "0x6E930b2dFA6f3249228ECdE7E6A137C0C208490C",
        //swUSDM
        "0x3c294C4834Cb8E51e24b6FF86a705863e214Dd85",
        //sWETH-wUSDM
        "0xA4bDE651A542e72D24d90cbBB6d28c01FAF8c981",
        //sUSDM-wUSDM
        "0xf7BEa61D5d144641B881aF9f11cE9c7c9b4DDe26",
        //swUSDPlus
        "0x7812315F4493182475127117d29Fc80531B3BC14",
        //sWETH-wUSDPlus
        "0x80C0f6A7B7DBB283153E88fAA35bFb408d2226B0",
        //sUSDC-wUSDPlus
        "0xDcD27451C18A7a82cf824c390FD085072bc5dc3d",
        //spsUSDz
        "0x73B295C3C09303eE463622D9a37D97E6a6417E9a",
        //sETH-sUSDz
        "0xf0d2C6C53fe96cAF52190E7149d5d2E9c400BeeB",
        //sUSDC-zUSDz
        "0x3dFa1c5eF6449844715FFFD0b5A2dB6f2E7B2Ef8",
        //sEURC
        "0x4145412374e0B5e6b59Be2dF0e36cb6917DfC52B",
        //sETH-EURC
        "0x9350Ed8c67c9A89F841b1A11393Dc8a271eDD4D9",
        //sUSDC-EURC
        "0x186bB9a98B756ce05C3E213A0b555837eb73F94D",
        //spwSuperOETHb 
        "0xA5ee652D7416928a0E521c10c2A0a92A4483Fc22",
        //sETH-wSuperOETHb 
        "0x77fD59c7D8a142408bd999a8078A7B3CD2EF102B",
        //sUSDC-wSuperOETHb 
        "0x9694812E0b6fc3CE5fF1ED67ace8cae2245c4510",
        //sphyUSD
        "0x9052BB2e39074020eB02905d49288dc9C27cc286",
        //sETH-hyUSD
        "0x21611EAF2cC359666b34f279D31e1d8787ae2843",
        //sUSDC-hyUSD
        "0x3E3b66D5fEE111982f0a4f04e5672ddAA6076127",
        //spumpBTC
        "0xc8F81ef93dc2520581ac66Ee9C26Ad0b862FBbB5",
        //sETH-pumpBTC
        "0x60873b783E1a87b4Ef72B9b5c18349bc186dCF4C",
        //sUSDC-pumpBTC
        "0xE48d3E0d75B040d3a35a0E689863c4a80c606bce",
      ]),
    },
  },
} as const);
